import React, { useEffect } from 'react';
import { Content, Header, PageContainer } from '../../Drawer/PageContainer';
import TenantGrid from './Components/TenantGrid';
import TenantSearchBar from './Components/TenantSearchBar';
import { useTenant } from '../../../Context/Tenant/TenantContext';
import InviteTenantDialog from './Components/InviteTenantDialog';
import { SET_LOADING, SET_PROJECTS, SET_TENANTS, TOGGLE_SHOW_INVITE_USER_DIALOG } from './TenantEvents';
import { useGlobalContext } from '../../../Renderers/GlobalContext';
import { getTenants } from '../../../API/Tenant/Tenant';
import { getCurrentSubscriptionForOrganisation } from '../../../API/Payment/Payment';
import { getOrganisationProjects } from '../../../API/Project/project';
import Loader from '../../Shared/Loader/loader';
import EditTenantDialog from './Components/EditTenantDialog';
import AddTenantAppDialog from './Components/AddTenantAppDialog';
import DeleteTenantAppDialog from './Components/DeleteTenantAppDialog';
import TenantNotification from './Components/TenantNotification';
import { useTranslation } from 'react-i18next';

const Tenants = () => {

    const { state: tenantState, dispatch: tenantDispatch } = useTenant();
    const { state: globalState, dispatch: globalDispatch } = useGlobalContext();
    const { organization } = globalState;

    useEffect(() => {
        const fetchTenants = async () => {
            try {
                let [tenants, subscription, projects] = await Promise.all([
                    getTenants(organization._id),
                    getCurrentSubscriptionForOrganisation(organization._id),
                    getOrganisationProjects(organization._id)
                ]);
                tenants = tenants.map(tenant => {
                    tenant.expanded = true;
                    return tenant;
                });
                tenantDispatch({ type: SET_TENANTS, payload: tenants });
                tenantDispatch({ type: SET_PROJECTS, payload: projects.filter(project => project.isActive) });
                globalDispatch({ type: "SET_SUBSCRIPTION", payload: subscription });
            } catch (error) {
                console.error(error);
            } finally {
                tenantDispatch({ type: SET_LOADING, payload: false });
            }
        };

        if (organization && organization._id) {
            fetchTenants();
        }
    }, [organization, tenantDispatch, globalDispatch]);


    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })

    if (tenantState.loading) return <Loader />

    return (
        <PageContainer>
            <Header
                hideBorder={true}
                actionText={t("new_tenant")}
                showAction={true}
                actionClicked={() => tenantDispatch({ type: TOGGLE_SHOW_INVITE_USER_DIALOG })}>
                <TenantSearchBar />
            </Header>
            <Content>
                {tenantState.showInviteUserDialog && <InviteTenantDialog />}
                {tenantState.showEditTenantDialog && <EditTenantDialog />}
                {tenantState.showAddTenantAppDialog && <AddTenantAppDialog />}
                {tenantState.showDeleteTenantAppDialog && <DeleteTenantAppDialog />}
                {tenantState.showNotification && <TenantNotification />}
                <TenantGrid />
            </Content>
        </PageContainer>
    );
}

export default Tenants;